import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { AUTH_TYPES } from "./allData";
import InfoTooltip from "@components/common/InfoTooltip";

type props = {
  authHeader: string;
  customAuthKey: string;
  username: string;
  password: string;
  authToken: string;
  handleAuthHeaderChange: (value: string) => void;
  setCustomAuthKey: (value: string) => void;
  handleUsernameChange: (value: string) => void;
  handlePasswordChange: (value: string) => void;
  handleAuthTokenChange: (value: string) => void;
};

const Authorization: React.FC<props> = ({
  authHeader,
  customAuthKey,
  username,
  password,
  authToken,
  handleAuthHeaderChange,
  setCustomAuthKey,
  handleUsernameChange,
  handlePasswordChange,
  handleAuthTokenChange,
}) => {
  const selectedAuthType = AUTH_TYPES.find((type) => type.value === authHeader);
  return (
    <>
      <div className="mt-4">
        <div className="flex items-center justify-between">
          <p className="font-bold text-md ml-1 text-primary drop-shadow-2xl">
            Authorization
          </p>

          <InfoTooltip
            text={`Enter or paste your saved authorization credentials ${authHeader === "basic" ? "(e.g., {{username}} or {{config.username}} and {{password}} or {{config.password}})" : "(e.g {{VARIABLE NAME}} or {{config.VARIABLE NAME}})."} `}
          />
        </div>

        <div className="flex items-start gap-2 mt-1 bg-muted p-2 rounded-md">
          <div className="w-1/3">
            <Select value={authHeader} onValueChange={handleAuthHeaderChange}>
              <SelectTrigger className="border p-2 rounded bg-background">
                <SelectValue>
                  {selectedAuthType?.label || "Select Auth Type"}
                </SelectValue>
              </SelectTrigger>

              <SelectContent>
                {AUTH_TYPES.map((m) => (
                  <SelectItem key={m.value} value={m.value}>
                    {m.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {authHeader === "Custom" && (
            <input
              type="text"
              placeholder="Custom header key"
              value={customAuthKey}
              onChange={(e) => setCustomAuthKey(e.target.value)}
              className="border p-2 bg-background rounded-md"
            />
          )}

          {authHeader === "basic" && (
            <div className="w-2/3 flex flex-col gap-2">
              <input
                type="text"
                placeholder="Enter saved variable.  "
                value={username}
                onChange={(e) => handleUsernameChange(e.target.value)}
                className="border p-2 rounded-md bg-background "
                required
              />
              <input
                type="password"
                placeholder="Enter saved variable.  "
                value={password}
                onChange={(e) => handlePasswordChange(e.target.value)}
                className="border p-2 rounded-md bg-background"
                required
              />
            </div>
          )}

          {authHeader !== "basic" && (
            <input
              type="text"
              placeholder="Enter saved variable. "
              value={authToken}
              onChange={(e) => handleAuthTokenChange(e.target.value)}
              className="flex-1 border p-2 rounded-md bg-background text-muted-foreground"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Authorization;
